// ==========================
// Version 2 - auth/emailVerification.js
// - Centralizes email/password verification checks
// - Centralizes email action settings
// ==========================

export function usesPasswordProvider(user) {
  return Array.isArray(user?.providerData)
    ? user.providerData.some((provider) => provider?.providerId === 'password')
    : false;
}

export function needsEmailVerification(user) {
  return !!user && usesPasswordProvider(user) && user.emailVerified !== true;
}

export function getEmailVerificationActionSettings() {
  const origin = typeof window !== 'undefined' ? window.location.origin : '';

  return {
    url: `${origin}/auth/action`,
    handleCodeInApp: true,
  };
}

// ==========================
// End Version 2 - auth/emailVerification.js
// ==========================
